var _rect, _rect2, _rect3, _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureRequestIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 3,
    height: 2,
    rx: 1,
    transform: "rotate(90 11 0)",
    fill: "#1847CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 3,
    height: 2,
    rx: 1,
    transform: "rotate(30 1 4)",
    fill: "#1847CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 18.5981 4)",
    fill: "#1847CA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.6407C15.7725 15.3782 16.9286 13.3063 16.9286 10.9643C16.9286 7.11802 13.8106 4 9.96429 4C6.11802 4 3 7.11802 3 10.9643C3 13.3376 4.18714 15.4336 6 16.6909V19H14V16.6407Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.6407L12.8397 15.0117L12 15.6098V16.6407H14ZM6 16.6909H8V15.6441L7.13981 15.0475L6 16.6909ZM6 19H4V21H6V19ZM14 19V21H16V19H14ZM14.9286 10.9643C14.9286 12.6321 14.108 14.1083 12.8397 15.0117L15.1603 18.2698C17.4371 16.6481 18.9286 13.9804 18.9286 10.9643H14.9286ZM9.96429 6C12.706 6 14.9286 8.22259 14.9286 10.9643H18.9286C18.9286 6.01345 14.9151 2 9.96429 2V6ZM5 10.9643C5 8.22259 7.22259 6 9.96429 6V2C5.01345 2 1 6.01345 1 10.9643H5ZM7.13981 15.0475C5.84266 14.1479 5 12.6543 5 10.9643H1C1 14.0209 2.53163 16.7193 4.86019 18.3343L7.13981 15.0475ZM8 19V16.6909H4V19H8ZM14 17H6V21H14V17ZM12 16.6407V19H16V16.6407H12Z",
    fill: "#1847CA",
    mask: "url(#path-4-inside-1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H13V20C13 20.5523 12.5523 21 12 21H8C7.44772 21 7 20.5523 7 20V18Z",
    stroke: "#1847CA",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureRequestIcon);
export default __webpack_public_path__ + "static/media/FeatureRequestIcon.7c28e422.svg";
export { ForwardRef as ReactComponent };